// extracted by mini-css-extract-plugin
export default {"searchContent":"SearchFieldWithDropdown_searchContent__ebhvs","section":"SearchFieldWithDropdown_section__nCsy5","highlighted":"SearchFieldWithDropdown_highlighted__H6cgU"};